import { render, staticRenderFns } from "./Pageheader.vue?vue&type=template&id=53aaad96&scoped=true"
import script from "./Pageheader.vue?vue&type=script&lang=ts"
export * from "./Pageheader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aaad96",
  null
  
)

export default component.exports